module.exports = __webpack_public_path__ + "43dff58184414ef98fcabdc068deeb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/galini.png
// module id = 511
// module chunks = 0